import type { ConfigCustomEvent } from "../modals/custom-event";
import { SelectTypeEnum, weekDaysLabels, type EventForDay } from "./utils";

export const deserializationEventData = (
  eventSelected?: EventForDay | undefined,
): ConfigCustomEvent | undefined => {
  if (!eventSelected) return undefined;

  switch (eventSelected.recurrence_type) {
    case SelectTypeEnum.DAILY_INTERVAL:
      return {
        repeatType: SelectTypeEnum.DAILY_INTERVAL,
        quantity: eventSelected?.recurrence_meta?.interval,
      } as ConfigCustomEvent;
    case SelectTypeEnum.WEEKLY_INTERVAL:
      return {
        repeatType: SelectTypeEnum.WEEKLY_INTERVAL,
        quantity: eventSelected?.recurrence_meta?.interval,
        dayToStart: eventSelected?.recurrence_meta?.weekdays?.[0].toString(),
      } as ConfigCustomEvent;
    case SelectTypeEnum.MONTHLY_INTERVAL:
      if (
        eventSelected.config_type === "day" &&
        eventSelected.recurrence_meta
      ) {
        const { days_of_month, rule, interval } = eventSelected.recurrence_meta;

        if (
          rule?.business_day_ordinal ||
          rule?.weekend_ordinal ||
          days_of_month?.length === 1
        ) {
          return {
            repeatType: SelectTypeEnum.MONTHLY_INTERVAL,
            quantity: interval,
            dateType: eventSelected.config_type,
            repeatStart: (rule?.business_day_ordinal ||
              rule?.weekend_ordinal ||
              (days_of_month?.[0] as number))!.toString(),
            repeatStartDay:
              days_of_month?.length === 1
                ? "Dia"
                : rule?.business_day_ordinal
                  ? "Dia de semana"
                  : "Fin de semana",
          } as unknown as ConfigCustomEvent;
        }

        if (rule?.week && rule.weekday) {
          return {
            repeatType: SelectTypeEnum.MONTHLY_INTERVAL,
            quantity: interval,
            dateType: eventSelected.config_type,
            repeatStart: rule.week.toString(),
            repeatStartDay: weekDaysLabels[rule.weekday - 1],
          } as unknown as ConfigCustomEvent;
        }
      }

      return {
        repeatType: SelectTypeEnum.MONTHLY_INTERVAL,
        quantity: eventSelected?.recurrence_meta?.interval,
        dateType: eventSelected.config_type ?? "Date",
        daysSelected: eventSelected?.recurrence_meta?.days_of_month,
      } as unknown as ConfigCustomEvent;
    case SelectTypeEnum.YEARLY_INTERVAL:
      if (
        eventSelected.config_type === "day" &&
        eventSelected.recurrence_meta
      ) {
        const { days_of_month, rule, interval, month } =
          eventSelected.recurrence_meta;

        if (
          rule?.business_day_ordinal ||
          rule?.weekend_ordinal ||
          days_of_month?.length === 1
        ) {
          return {
            monthSelected: month?.toString(),
            repeatType: SelectTypeEnum.YEARLY_INTERVAL,
            quantity: interval,
            dateType: eventSelected.config_type,
            repeatStart: (rule?.business_day_ordinal ||
              rule?.weekend_ordinal ||
              (days_of_month?.[0] as number))!.toString(),
            repeatStartDay:
              days_of_month?.length === 1
                ? "Dia"
                : rule?.business_day_ordinal
                  ? "Dia de semana"
                  : "Fin de semana",
          } as unknown as ConfigCustomEvent;
        }

        if (rule?.week && rule?.weekday) {
          return {
            monthSelected: month?.toString(),
            repeatType: SelectTypeEnum.YEARLY_INTERVAL,
            quantity: eventSelected?.recurrence_meta?.interval,
            dateType: eventSelected.config_type,
            repeatStart: rule.week.toString(),
            repeatStartDay: weekDaysLabels[rule.weekday - 1],
          } as unknown as ConfigCustomEvent;
        }
      }

      return {
        monthSelected: eventSelected.recurrence_meta?.month?.toString(),
        repeatType: SelectTypeEnum.YEARLY_INTERVAL,
        quantity: eventSelected?.recurrence_meta?.interval,
        dateType: eventSelected.config_type ?? "Date",
        daysSelected: eventSelected?.recurrence_meta?.days_of_month,
      } as unknown as ConfigCustomEvent;
    default:
      return undefined;
  }
};
